// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"183":"a7a900bb","787":"1a499423"}[chunkId] + ".chunk.js";
};